$(document).on('turbolinks:load', function() {
  function openQa(section) {
    var $qa = $('.top-section--' + section);

    $qa.find('.top-section__inner__qa__content__button__mark').addClass('active');
    $qa.children('.top-section__inner__qa__content__a').stop(true, true).slideDown();
  }

  $('.top-section__inner__qa__content').off('click.qa').on('click.qa', function() {
    $(this).find('.top-section__inner__qa__content__button__mark').toggleClass('active')
    $(this).children('.top-section__inner__qa__content__a').slideToggle();
  });

  // #qaN が付いていたら QA セクションの N 番目の項目を active にする
  var section = $(location).attr('hash');
  if (section) {
    section = section.replace('#', '');
    if (/^qa\d+$/.test(section)) {
      openQa(section);
    }
  }

  $('.vpn-warning-qa-link').off('click.vpnWarningQa').on('click.vpnWarningQa', function(event) {
    var targetSection = this.hash.replace('#', '');
    var $target = $('.top-section--' + targetSection);

    if (!/^qa\d+$/.test(targetSection) || !$target.length) {
      return;
    }

    event.preventDefault();
    $('.vpn-ip-modal__close').trigger('click', [false]);
    openQa(targetSection);
    $target.attr('tabindex', '-1').get(0).focus({preventScroll: true});

    if (window.history && window.history.pushState) {
      window.history.pushState(null, '', '#' + targetSection);
    }
    else {
      window.location.hash = targetSection;
    }

    $('html,body').stop(true).animate({scrollTop: $target.offset().top - 150 + 1}, 500);
  });
});
